module.exports = __webpack_public_path__ + "static/media/LD_DatenDEPOT_Logo_ab_2025.d28b885f.png";